/**
 * Limits for admin-authored help text shown to the farmer: a document
 * requirement's `informationText` and a form field's `description`.
 *
 * One number for both, read by the backend DTOs and the admin editors, so the
 * UI counter and the API validation cannot drift apart again (AG-283). Long
 * texts with lists are expected (AG-272), hence the generous limit.
 *
 * Plain TypeScript, no runtime dependencies — consumed as source by both the
 * Vite bundle and the NestJS build.
 */
export const HELP_TEXT_MAX_LENGTH = 5000;
